import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditPencil = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_677_5671)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.3333 9.33337C13.3333 11.2002 13.3333 12.1336 12.9699 12.8467C12.6504 13.4739 12.1405 13.9838 11.5133 14.3034C10.8002 14.6667 9.86679 14.6667 7.99992 14.6667H6.66659C4.79975 14.6667 3.86633 14.6667 3.15329 14.3034C2.52608 13.9838 2.01614 13.4739 1.69657 12.8467C1.33325 12.1336 1.33325 11.2002 1.33325 9.33337V8.00004C1.33325 6.1332 1.33325 5.19978 1.69657 4.48674C2.01614 3.85953 2.52608 3.34959 3.15329 3.03002C3.86633 2.66671 4.79975 2.66671 6.66659 2.66671M5.37429 9.00104C5.38007 8.76724 5.38295 8.65031 5.41122 8.54044C5.43629 8.44304 5.47598 8.35011 5.52894 8.26471C5.58867 8.16844 5.67101 8.08571 5.83569 7.92031L12.0999 1.62059C12.4247 1.29434 12.932 1.23967 13.3183 1.48928C13.7763 1.78519 14.1677 2.17404 14.4671 2.63086C14.4839 2.65651 14.5012 2.68195 14.5173 2.70801C14.7679 3.11155 14.6861 3.62218 14.3573 3.95245L8.14239 10.2027C7.97152 10.3743 7.88612 10.4601 7.78645 10.5214C7.69805 10.5757 7.60165 10.6157 7.50085 10.6399C7.38719 10.6672 7.26639 10.667 7.02479 10.6666L5.33325 10.6639L5.37429 9.00104Z",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_677_5671",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "currentColor"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgEditPencil);
export default ForwardRef;
